import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function BirthdaySection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const invitationsUrl = 'https://cdn.magicpatterns.com/uploads/kUwZiG6ZzsPg9cwh4H84nG/lYdufRT7f0DYU-2-4EXEIEzqZIghsk5Er47sxNGaABiqCUc8jKf7g3hvAB5FB_UXRcmrbKSMWUFzH22_h86uNssQJDgZwCiAFFbW9zyikT4.jpg';
  const collageUrl = 'https://cdn.magicpatterns.com/uploads/ietsRzgTArHniV3NYUhdp9/il_570xN.6630464415_bgu3.webp';
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = ['Invitaciones', 'Banderines', 'Topper para torta', 'Decoración de mesa', 'Números 3D', 'Flores de papel'];
  return <section className="w-full bg-white py-20 sm:py-28 overflow-hidden" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <motion.h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-6" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-13">
            🎂 Organiza cumpleaños increíbles en minutos
          </motion.h2>
          <motion.p className="text-xl text-slate-600 max-w-2xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-14">
            Con este kit puedes decorar fiestas infantiles sin gastar una
            fortuna.
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-15">
          {/* Images Column */}
          <div className="flex-1 relative w-full" data-id="element-16">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="space-y-6" data-id="element-17">
              <img src={invitationsUrl} alt="" className="w-full h-auto rounded-3xl shadow-xl object-cover border-4 border-white" loading="lazy" data-id="element-18" />
              <img src={collageUrl} alt="" className="w-full h-auto rounded-3xl shadow-lg object-cover border-4 border-white" loading="lazy" data-id="element-19" />
            </motion.div>
          </div>

          {/* Content Column */}
          <div className="flex-1 w-full mt-16 lg:mt-0 lg:pl-10" data-id="element-20">
            <motion.div className="bg-pink-50 rounded-2xl p-6 sm:p-8 mb-8 shadow-sm border border-pink-100" initial={{
            opacity: 0,
            x: 30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-21">
              <p className="font-bold text-slate-800 mb-4 text-lg" data-id="element-22">
                Solo necesitas:
              </p>
              <div className="flex flex-col sm:flex-row gap-4 font-semibold text-rose-600" data-id="element-23">
                <span className="bg-white px-4 py-2 rounded-lg shadow-sm" data-id="element-24">
                  1️⃣ Descargar
                </span>
                <span className="hidden sm:block text-slate-300 self-center" data-id="element-25">
                  →
                </span>
                <span className="bg-white px-4 py-2 rounded-lg shadow-sm" data-id="element-26">
                  2️⃣ Imprimir
                </span>
                <span className="hidden sm:block text-slate-300 self-center" data-id="element-27">
                  →
                </span>
                <span className="bg-white px-4 py-2 rounded-lg shadow-sm" data-id="element-28">
                  3️⃣ Decorar
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-29">
              <h3 className="text-xl font-bold text-slate-900 mb-6" data-id="element-30">
                Incluye:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-31">
                {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-32">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center" data-id="element-33">
                      <CheckIcon className="w-4 h-4 text-green-600" data-id="element-34" />
                    </div>
                    <span className="text-slate-700 font-medium" data-id="element-35">{item}</span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-8 text-center" data-id="element-36">
              <p className="text-amber-800 font-bold text-lg" data-id="element-37">
                🎉 26 carpetas con más de 1000 diseños cada una, listos para
                imprimir.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.6
          }} data-id="element-38">
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-39">
                👉 Acceder al Mega Kit — $27.990 ARS
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}